// ** Initial State
const initialState = {
    result_list: [],
    result: null,
    total: 0
}

const paymentAnalyze = (state = initialState, action) => {
    switch (action.type) {
        case 'WALLET_ANALYZE':
            return {
                ...state,
                result: action.data
            }
        default:
            return { ...state }
    }
}

const paymentSummary = (state = initialState, action) => {
    switch (action.type) {
        case 'WALLET_SUMMARY':
            return {
                ...state,
                result: action.data
            }
        default:
            return { ...state }
    }
}

const paymentFeeSummary = (state = initialState, action) => {
    switch (action.type) {
        case 'WALLET_FEE_SUMMARY':
            return {
                ...state,
                result: action.data
            }
        default:
            return { ...state }
    }
}

const paymentFeeDetailSummary = (state = initialState, action) => {
    switch (action.type) {
        case 'WALLET_FEE_DETAIL_SUMMARY':
            return {
                ...state,
                result: action.data
            }
        default:
            return { ...state }
    }
}

export {
    paymentAnalyze,
    paymentSummary,
    paymentFeeSummary,
    paymentFeeDetailSummary
}
